import { render, staticRenderFns } from "./CandidateCareerPage.vue?vue&type=template&id=820235ec&scoped=true"
import script from "./CandidateCareerPage.vue?vue&type=script&lang=js"
export * from "./CandidateCareerPage.vue?vue&type=script&lang=js"
import style0 from "./CandidateCareerPage.vue?vue&type=style&index=0&id=820235ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820235ec",
  null
  
)

export default component.exports